import { axiosGet } from "../../react_axios/Axios"
import { getFillListUrl, GET_FILL_LIST_ACTION_TYPE, headers, getHdrDtlUrl, GET_HDR_DTL_ACTION_TYPE, award_event_id } from "../../utils/constants"

export const fill_action = (actionID, user_id, keyword, keyvalue) => async (dispatch) => {

    try {
        const mapdata = {
            ActionID: actionID,
            user_id: user_id,
            keyword: keyword,
            keyvalue: keyvalue,
        }
        const res = await axiosGet(getFillListUrl, mapdata, headers);
        dispatch({
            type: GET_FILL_LIST_ACTION_TYPE,
            payload: res,
        });
        return Promise.resolve(res);
    } catch (err) {
        return Promise.reject(err);
    }
};

export const get_hdr_dtl_action = (user_id, role_id) => async (dispatch) => {

    try {
        const mapdata = {
            user_id: user_id,
            role_id: role_id,
            award_event_id: sessionStorage.getItem("award_event_id")||1,
        }
        const res = await axiosGet(getHdrDtlUrl, mapdata, headers);
        dispatch({
            type: GET_HDR_DTL_ACTION_TYPE,
            payload: res,
        });
        return Promise.resolve(res);
    } catch (err) {
        return Promise.reject(err);
    }
};

